module.exports = __webpack_public_path__ + "img/imgSrc5.3dc08a27.png";